import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { OnboardingGate } from './components/auth/OnboardingGate';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppNavigationProvider } from './context/AppNavigationContext';
import { AuthProvider } from './context/AuthContext';
import { TenantViewProvider } from './context/TenantViewContext';
import { ThemeProvider } from './context/ThemeContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { PageDashboardProvider } from './context/PageDashboardContext';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { LoginPage } from './pages/auth/LoginPage';
import { OnboardingPage } from './pages/auth/OnboardingPage';

function AppProviders({ children }) {
  return (
    <TenantViewProvider>
      <ThemeProvider>{children}</ThemeProvider>
    </TenantViewProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <AppProviders>
                  <OnboardingPage />
                </AppProviders>
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <OnboardingGate>
                  <AppProviders>
                    <AppNavigationProvider>
                      <CurrencyProvider>
                        <PageDashboardProvider>
                          <AppShell>
                            <DashboardPage />
                          </AppShell>
                        </PageDashboardProvider>
                      </CurrencyProvider>
                    </AppNavigationProvider>
                  </AppProviders>
                </OnboardingGate>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
